import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { constructionSiteColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import { EnumFrontendLayoutSetting, type ApiConstructionSite } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { ConstructionSitesRepository } from '@Repositories/Stammdaten';

export function FrameListConstructionSite() {
    const hasPermission = useHasPermission();

    const module = useListApi(ConstructionSitesRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiConstructionSite>
            layoutSettingsContext={EnumFrontendLayoutSetting.ConstructionSitesTableLayout}
            name="ConstructionSiteList"
            columns={constructionSiteColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenConstructionSiteCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
